// src/utils/api.js

const API_URL = process.env.REACT_APP_API_URL || "/api/";

class Api {
  static patch(endpoint, body, token = null) {
    return this.request(endpoint, "PATCH", body, token);
  }
  static async request(endpoint, method = "GET", body = null, token = null) {
    const headers = { "Content-Type": "application/json" };
    // Always use token from argument, or fallback to localStorage
    const authToken = token || localStorage.getItem("token");
    if (authToken) headers["Authorization"] = `Bearer ${authToken}`;
    const options = {
      method,
      headers,
    };
    if (body) options.body = JSON.stringify(body);
    let res, data;
    try {
      res = await fetch(`${API_URL}${endpoint}`, options);
    } catch (err) {
      // Network error (server down, CORS, etc)
      if (typeof window !== "undefined" && window.showApiServerDownMessage) {
        window.showApiServerDownMessage(
          "Unable to connect to the server. Please try again later.",
        );
      }
      throw new Error("API server unreachable");
    }
    data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.message || "API Error");
    }
    return data;
  }

  static get(endpoint, token = null) {
    return this.request(endpoint, "GET", null, token);
  }

  static post(endpoint, body, token = null) {
    return this.request(endpoint, "POST", body, token);
  }

  static put(endpoint, body, token = null) {
    return this.request(endpoint, "PUT", body, token);
  }

  static delete(endpoint, token = null) {
    return this.request(endpoint, "DELETE", null, token);
  }
}

export default Api;
